import * as fromDatatype from "../../../../models/datatype-library";

export class GenericDocSearchCriteriaDtoModel {
    guids?: any [];
    date_txn_to?: fromDatatype.TimestampTzDatatypeInterface;
    date_txn_from?: fromDatatype.TimestampTzDatatypeInterface;
    created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    created_date_from?: fromDatatype.TimestampTzDatatypeInterface; 
    updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    updated_date_from?: fromDatatype.TimestampTzDatatypeInterface; 
    delivery_date_expected_to?: fromDatatype.TimestampTzDatatypeInterface; 
    delivery_date_expected_from?: fromDatatype.TimestampTzDatatypeInterface; 
    delivery_driver_guids?: any [];
    server_docs_1?: any [];
    server_docs_2?: any [];
    server_docs_3?: any [];
    server_docs_4?: any [];
    server_docs_5?: any [];
    client_docs_1?: any [];
    client_docs_2?: any [];
    client_docs_3?: any [];
    client_docs_4?: any [];
    client_docs_5?: any [];
    guid_branchs?: any [];
    store_guids?: any []; //location from
    store_guids2?:any[]; // location to
    doc_entity_hdr_guids?: any [];
    server_doc_locations?: any [];
    member_guids?: any [];
    processes?: any [];
    posting_statuses?: any [];
    contact_hdr_guids?: any [];
    hdr_del_region_hdr_guids?: any [];
    sales_entity_hdr_guids?: any [];
    hdr_track_delivery_guids?: any [];
    hdr_track_production_guids?: any [];
    limit?: number;
    search_word?: string;
    marketplace_status?: string;
    marketplace_payment_status?: string;
    mkt_order_no?: string;
    hdr_pic_entity_01_guids?: any [];
    status? : string;
    gl_dimension_guids?: any [];
    segment_guids?: any [];
    profit_center_guids?: any [];
    project_guids?: any [];
    einvoice_billing_frequencies?: string [];
    einvoice_billing_period_start_from?: fromDatatype.TimestampTzDatatypeInterface;
    einvoice_billing_period_start_to?: fromDatatype.TimestampTzDatatypeInterface;
    einvoice_billing_period_end_from?: fromDatatype.TimestampTzDatatypeInterface;
    einvoice_billing_period_end_to?: fromDatatype.TimestampTzDatatypeInterface;
  }
  